export const Configuration = {
  api: {
    base: process.env.VUE_APP_API + "/api",
    // sii: 'http://52.67.252.22:3001/consulta/'
    sii: "https://api.redcapital.cl/inicio_actividades/",
    sii2: process.env.VUE_APP_API + "/api/sii/terceros?rut=",
    landing: "https://landing.redcapital.cl/api/leads?h="
  },
  Refresh: {
    Timeout: 10 * 1000
  },
  Redirection: {
    timeout: 1 * 2000 // Seconds * Milliseconds
  },
  Analytics: {
    UA: process.env.VUE_APP_UA,
    Name: process.env.VUE_APP_NAME
  },
  validar_facturas_cotizacion:{
    cotizar: process.env.VUE_APP_FACTURAS,
  }
};

export const SelectedCountry: any = process.env.VUE_APP_SELECTED_COUNTRY;
export const Backend: any = process.env.VUE_APP_API;
export const SocketPort: any = process.env.VUE_APP_SOCKET_PORT;
export const PusherKey: any = process.env.VUE_APP_PUSHER_APP_KEY;
export const PusherCluster: any = process.env.VUE_APP_PUSHER_CLUSTER;
export const ShowDebug: any =
  process.env.VUE_APP_SHOW_DEBUG !== undefined ? true : false;
export const State: any =
  process.env.VUE_APP_STATE !== undefined ? process.env.VUE_APP_STATE : 1;

export const RedCapital = {
  CO: {
    Id: "1",
    Name: "Colombia",
    GentilName: "colombiano",
    Url: "https://redcapital.com.co",
    Dni: "76.400.275-K",
    BusinessName: "RedCapital SPA",
    Logo: "/images/logo-redcapital-head.png",
    PhoneCode: "+57",
    Lang: "es",
    DniName: "CC/CE/PAS",
    DniBusiness: "Nit",
    Currency: {
      Name: "COL",
      Prefix: "$",
      Suffix: "",
      LocaleString: "es-ES"
    },
    Contact: {
      Mail: "servicio_cliente@iris.com.co",
      Phone: "+57 318 7119180",
      Phone2: "+57 313 8700898",
      AddressName: "Calle 127 #70G - 78 Bogotá D.C.",
      AddressLink: "https://goo.gl/maps/oMtNxJ2azKPDm3ks5",
      AddressName2: null,
      AddressLink2: null,
      Timetable: "Lunes a Viernes de 08:00 a 18:00 Hrs",
      Timetable2: null,
      LinkedIn: "https://www.linkedin.com/company/irisfinanciera/",
      // Twitter: "https://twitter.com/_redcapital"
    },
    Project: {
      MinInvest: 1000000,
      ClubAmount: 50000,
      PublicVisibility: true,
      TirDecimalsCount: 2
    },
    Account: {
      Bank: "",
      Type: "",
      Number: "",
      Name: "",
      Dni: ""
    }
  }, 
};

export const RedCapitalConfig = (country: string): any => {
  // @ts-ignore
  return RedCapital[country];
};

export const TitleTemplatePublic = "%s | IRIS";
export const TitleTemplateDashboard = "%s - Panel";

export const Countries = [
  {
    id: 1,
    country: "Chile",
    nationality: "Chilena"
  },
  {
    id: 2,
    country: "Argentina",
    nationality: "Argentina"
  },
  {
    id: 3,
    country: "Peru",
    nationality: "Peruana"
  },
  {
    id: 4,
    country: "Estados unidos",
    nationality: "Estadounidense"
  }
];
